import React, { useEffect } from "react";
import { initialSpinnerState } from "store/modules/common/spinnerReducer";
import { useSelector } from "react-redux";
import useSpinner from "store/customHooks/useSpinner";
import styled, { css } from "styled-components";

function LoadingSpinner() {
    const { closeSpinner } = useSpinner();
    const { isShow, size, color, backdropColor } = useSelector((state) => state.spinnerReducer);
    // console.log("isShow, size, color, backdropColor : ", isShow, size, color, backdropColor);

    useEffect(() => {
        return () => closeSpinner();
    }, []);

    if (!isShow) return null;

    return (
        <SpinnerWrap color={backdropColor || initialSpinnerState.backdropColor}>
            <Spinner size={size || initialSpinnerState.size} color={color || initialSpinnerState.color}>
                <svg className="spinner" viewBox="0 0 50 50">
                    <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
                </svg>
                <div className="background_backdrop" />
            </Spinner>
        </SpinnerWrap>
    );
}

const SpinnerWrap = styled.div`
    ${({ color }) => {
        return css`
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1040;

            // deep 영역
            .background_backdrop {
                position: fixed;
                bottom: 0;
                left: 0;
                z-index: 1050;
                width: 100%;
                height: 100%;
                opacity: 0.4;
                background-color: ${color};
            }
        `;
    }}
`;

const Spinner = styled.div`
    ${({ size, color }) => {
        return css`
            .spinner {
                animation: rotate 2s linear infinite;
                position: absolute;
                top: 50%;
                left: 50%;
                margin: ${-(size / 2)}px 0 0 ${-(size / 2)}px;
                width: ${size}px;
                height: ${size}px;
                z-index: 1060;

                & .path {
                    stroke: ${color};
                    stroke-linecap: round;
                    animation: dash 0.6s ease-in-out infinite;
                }
            }

            @keyframes rotate {
                100% {
                    transform: rotate(360deg);
                }
            }

            @keyframes dash {
                0% {
                    stroke-dasharray: 1, 150;
                    stroke-dashoffset: 0;
                }
                50% {
                    stroke-dasharray: 90, 150;
                    stroke-dashoffset: -35;
                }
                100% {
                    stroke-dasharray: 90, 150;
                    stroke-dashoffset: -124;
                }
            }
        `;
    }}
`;

export default LoadingSpinner;
